import { useMount } from 'react-use';
import { useMemo } from 'react';
import useLocalDispatch from 'hooks/useLocalDispatch';
import { Card, CardContent, CardHeader, Box, Paper } from '@mui/material';
import { TargetService } from 'types';
import {
  FetchDataOverviewPerDataTypesParams,
  FetchDataOverviewPerDataTypesSuccessResponse,
  DataOverviewPerDatatypeResponseInstance,
} from 'IntegrationModule/types';
import DataTypeUpdatesOverviewChart from './DataTypeUpdatesOverviewChart';
import DataTypeUpdatesOverviewTable from './DataTypeUpdatesOverviewTable';
import { fetchDataOverviewPerDataTypes } from 'thunk';
import keyBy from 'lodash/keyBy';
import { DataType } from '@constants';

const fetchDataOverviewByDataTypeStateId = 'fetchDataOverviewByDataTypeStateId';

export type FetchDataOverviewByDataTypeState = {
  dataOverviewByDataTypeHash: Record<DataType, DataOverviewPerDatatypeResponseInstance>;
};

export type FetchIntegrationsLastUpdateState = Record<string, never>;

const DataTypeUpdatesOverview = ({
  targetService,
  targetServiceId,
}: {
  targetServiceId: number;
  targetService: TargetService;
}) => {
  const { dispatchLocal, selectLocalData } = useLocalDispatch();

  const { data: dataOverviewByDataTypeState, isRequesting: isFetchingDataOverviewByDataTypeData } =
    selectLocalData<FetchDataOverviewByDataTypeState>({
      stateId: fetchDataOverviewByDataTypeStateId,
    });

  const { dataOverviewByDataTypeHash } = dataOverviewByDataTypeState || {};

  useMount(() => {
    dispatchLocal<
      FetchDataOverviewByDataTypeState,
      FetchDataOverviewPerDataTypesParams,
      FetchDataOverviewPerDataTypesSuccessResponse
    >(fetchDataOverviewPerDataTypes, {
      params: { targetServiceIds: [targetServiceId] },
      stateId: fetchDataOverviewByDataTypeStateId,
      formatSuccessResponse: ({ response }) => {
        const nextState = {
          dataOverviewByDataTypeHash: keyBy(
            response.data,
            'dataType',
          ) as FetchDataOverviewByDataTypeState['dataOverviewByDataTypeHash'],
        };

        return nextState;
      },
    });
  });

  const isLoading = isFetchingDataOverviewByDataTypeData;

  return (
    <Paper style={{ height: '35rem' }}>
      <CardHeader title="Overview Per Data Types" />
      <CardContent>
        <DataTypeUpdatesOverviewChart
          isLoading={isLoading}
          dataOverviewByDataTypeHash={dataOverviewByDataTypeHash}
        />
        <DataTypeUpdatesOverviewTable
          isLoading={isLoading}
          dataOverviewByDataTypeHash={dataOverviewByDataTypeHash}
        />
      </CardContent>
    </Paper>
  );
};

export default DataTypeUpdatesOverview;
